export function normalizeBrandWebsiteUrl(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return '';

  const isHostWithPort = /^(?:[a-z\d-]+(?:\.[a-z\d-]+)+|localhost):\d+(?:[/?#]|$)/i.test(trimmed);
  const hasScheme = /^[a-z][a-z\d+.-]*:/i.test(trimmed) && !isHostWithPort;
  const candidate = trimmed.startsWith('//')
    ? `https:${trimmed}`
    : hasScheme ? trimmed : `https://${trimmed}`;
  // URL parsing removes embedded authority tabs/newlines; reject them before normalization.
  const authority = candidate.match(/^https?:\/\/([^/?#]*)/i)?.[1] || '';
  if (/\s/u.test(authority)) return null;
  try {
    const url = new URL(candidate);
    return (url.protocol === 'http:' || url.protocol === 'https:')
      && url.hostname && !/[\s%]/u.test(url.hostname) && !url.username && !url.password
      ? candidate
      : null;
  } catch {
    return null;
  }
}
